class HHLocalWeather extends HTMLElement {
  constructor() {
    super()

    this.apiKey = this.getAttribute('data-api-key')
    this.city = this.getAttribute('data-city')

    this.getWeather = this.getWeather.bind(this)
  }

  connectedCallback() {
    if (!this.apiKey || !this.city) return

    this.getWeather()
  }

  getWeather() {
    fetch(`https://api.weatherapi.com/v1/forecast.json?key=${this.apiKey}&q=${this.city}&days=1&aqi=no&alerts=no`)
      .then(res => res.json())
      .then(res => {
        if (res) {
          let icon = document.createElement('img');
          icon.src = res.current.condition.icon
          icon.alt = ''
          icon.role = 'presentation'
          this.appendChild(icon);
          let weather = document.createElement('span')
          weather.innerText = res.location.country == 'United States of America' ? `${res.current.temp_f} °F` : `${res.current.temp_c} °C`
          this.appendChild(weather)
        }
      })
  }
}

customElements.define('hh-local-weather', HHLocalWeather)
